//require("../../assets/stylesheets/smb/application.tailwind.css")
// Register React components with ReactOnRails
import '../styles/application.tailwind.css';
import ReactOnRails from 'react-on-rails';

import MssDashboard from "@/components/dashboard/mss-dashboard";
// import UserMenu from "../../../app/views/dash/shared/UserMenu";
import MssHeader from '@/components/header/mss-header';
import MssPublishWidget from '@/components/header/mss-publish-widget';
import Breadcrumbs from '@/components/breadcrumbs/mss-breadcrumbs';
import MssAppSidebar from '@/components/sidebar/mss-app-sidebar';
import MssLogin from '@/components/account/mss-login';
import MssForgotPassword from '@/components/account/mss-forgot-password';
import MssEditPassword from '@/components/account/mss-edit-password';
import MssAcceptInvitation from '@/components/account/mss-accept-invitation';

// NEW: global toaster host
import ToasterHost from "@/components/shared/mss-toaster-host";

ReactOnRails.register({
  MssHeader,
  MssPublishWidget,
  Breadcrumbs,
  MssAppSidebar,
  ToasterHost,
  MssLogin,
  MssForgotPassword,
  MssEditPassword,
  MssAcceptInvitation,
});
